import { PageHeader } from "@/components/shared";
import { ChannelOrdersPanel } from "@/components/channel/ChannelOrdersPanel";
import { useChannelDesk } from "@/lib/channel-desk";

const StoreSupplyOrders = () => {
  const desk = useChannelDesk();
  return (
    <div className="space-y-6">
      <PageHeader
        title="Store Supply Orders"
        description="View and track your inventory purchase orders placed with your wholesale channel partner."
      />
      <ChannelOrdersPanel mode="party" sections={["incoming"]} />
    </div>
  );
};

export default StoreSupplyOrders;
